jQuery(function($){

  $('html').removeClass('no-js');
                    
  /* Placeholder JS */
  /*==========================*/

  $('[placeholder]').each(function(){
    if ($(this).val() === '') {
      var hint = $(this).attr('placeholder');
      $(this).val(hint).addClass('hint');
    }
  });

  $('[placeholder]').focus(function() {
    if ($(this).val() === $(this).attr('placeholder')) {
      $(this).val('').removeClass('hint');
    }
  }).blur(function() {
    if ($(this).val() === '') {
      $(this).val($(this).attr('placeholder')).addClass('hint');
    }
  });                    

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });
  
  
  /* Slider */
  /*============================*/
  
var sliderUL = $('div.slider').css('overflow', 'hidden').children('ul'),
	imgs = sliderUL.find('img'),
	imgWidth = imgs[0].width,
	imgsLen = imgs.length, // 4
	current = 1,
	totalImgsWidth = imgsLen * imgWidth; // 2400

$('#slider-nav').css('display', 'inline').find('button').on('click', function() {
	var direction = $(this).data('dir'),
		loc = imgWidth; // 600

	// update current value 
	( direction === 'next' ) ? ++current : --current;

	// if first image
	if ( current === 0 ) {
		current = imgsLen;
		loc = totalImgsWidth - imgWidth; // 2400 - 600 = 1800
		direction = 'next';
	} else if ( current - 1 === imgsLen ) { // Are we at end? Should we reset?
		current = 1;
		loc = 0;
	}

	transition(sliderUL, loc, direction);
});

function transition( container, loc, direction ) {
	var unit; // -= +=

	if ( direction && loc !== 0 ) {
		unit = ( direction === 'next' ) ? '-=' : '+=';
	}

	container.animate({
		'margin-left': unit ? (unit + loc) : loc
	});
}

});
